module.exports = __webpack_public_path__ + "static/lung-8d3318ac542fd5d0bba3f33b44662489.jpg";